import dayjs from "dayjs";
import { DefectReason, Mark } from "../../../../../../enums";

export const getInitialValues = (products, offlineData) => {
  const newProductsList = products?.productList?.map((product, index) => {
    const apiDlc = Array.isArray(product.dlc)
      ? dayjs(new Date(product.dlc[0], product.dlc[1] - 1, product.dlc[2]))
      : product.dlc ? dayjs(product.dlc) : null

    const offlineDlc = offlineData?.[`offlineProductList[${index}].dlc`]
    const initialDlc = offlineDlc && offlineDlc !== "Invalid Date"
      ? dayjs(offlineDlc)
      : apiDlc

    const markVal = offlineData?.[`offlineProductList[${index}].mark`] ?? product.mark
    const defectVal = offlineData?.[`offlineProductList[${index}].defectReason`] ?? product.defectReason
    const integral = offlineData?.[`offlineProductList[${index}].integral`] ?? product.integral ?? 0
    const broken   = offlineData?.[`offlineProductList[${index}].broken`]   ?? product.broken   ?? 0
    const qty       = product.quantity ?? 0
    const dev       = (product.shopReceptionDeviation ?? 0) / 1000
    const total     = integral + broken

    let litigation: 0 | 1 | 2
    let marks: Mark[] = []

    if (qty > integral + dev && total === qty) {
      litigation = 2
      marks = [
        Mark.VEGETABLE_FRUIT_QUALITY,
        Mark.EXPIRED,
        Mark.SHORT_TERM,
        Mark.DAMAGED,
        Mark.VEGETABLES_FRUITS,
        Mark.DETERIORATION_A
      ]
    } else if (qty > integral + dev && total !== qty) {
      litigation = 1
      marks = [
        Mark.PALLETS_MERCHANDISE_MISSING,
        Mark.MISSING_CARRIER,
        Mark.QUANTITATIVE_DIFFERENCE
      ]
    } else if (qty < integral - dev) {
      litigation = 1
      marks = [
        Mark.PALLETS_MERCHANDISE_MISSING,
        Mark.QUANTITATIVE_DIFFERENCE
      ]
    } else {
      litigation = 0
    }

    let defectReasons: DefectReason[] = []
    if (litigation === 1) {
      defectReasons = [DefectReason.PROVIDER]
    } else if (litigation === 2) {
      if (markVal === Mark.EXPIRED || markVal === Mark.SHORT_TERM) {
        defectReasons = [DefectReason.PROVIDER]
      } else if (markVal === Mark.VEGETABLE_FRUIT_QUALITY) {
        defectReasons = [DefectReason.PROVIDER, DefectReason.SHOP]
      } else if (markVal === Mark.DAMAGED) {
        defectReasons = [
          DefectReason.PROVIDER,
          DefectReason.TRANSPORTER,
          DefectReason.SHOP
        ]
      } else if (
        markVal === Mark.VEGETABLES_FRUITS ||
        markVal === Mark.DETERIORATION_A
      ) {
        defectReasons = [
          DefectReason.PROVIDER,
          DefectReason.TRANSPORTER
        ]
      }
    }

    const defLabel = (DefectReason as Record<string,string>)[defectVal] || defectVal;
    const markLabel = (Mark as Record<string,string>)[markVal] ?? markVal

    return {
      ...product,
      broken: offlineData?.[`offlineProductList[${index}].broken`] ?? product.broken,
      integral: offlineData?.[`offlineProductList[${index}].integral`] ?? product.integral,
      mark: markLabel,
      defectReason: defLabel,
      marks,
      defectReasons,

      dlc: initialDlc,
      productDlc: initialDlc,
      showDlc: product.dlc !== null || product.shortDlc === true
    }
  })
  return { ...products, productList: newProductsList ?? [] }
}
